module.exports = __webpack_public_path__ + "static/media/paragraph-justify.44b8aae4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/paragraph-justify.svg
// module id = 3275
// module chunks = 7